export const FLAG_GETTING_PREVENTIVE_TASK_PROJECTIONS =
  'FLAG_GETTING_PREVENTIVE_TASK_PROJECTIONS';
export const GET_PREVENTIVE_TASK_PROJECTIONS =
  'GET_PREVENTIVE_TASK_PROJECTIONS';
export const CLEAR_PREVENTIVE_TASK_PROJECTIONS =
  'CLEAR_PREVENTIVE_TASK_PROJECTIONS';
